import { FunctionComponent, ReactElement } from 'react';
import SearchInput, { SearchInputProps } from '../search-input/SearchInput';

type SearchInputTableProps = Pick<SearchInputProps, 'value' | 'label' | 'onChange'>;

const SearchInputTable: FunctionComponent<SearchInputTableProps> = ({
	label,
	onChange,
	...rest
}): ReactElement => <SearchInput {...{ label, onChange }} sx={{ width: '220px' }} {...rest} />;

export default SearchInputTable;
